// Proportional ("cqi-equivalent") sizing with a shared readability floor.
// Web and native share the exact same math — at the same `tileSize` they
// render identically — which is the load-bearing invariant for this
// component. The floor kicks in only on thumbnail-sized cards (the default
// 88px phone tile), keeping the due line readable; on larger cards the
// floor is inert and the text scales like a CSS `transform: scale` of the
// thumbnail.
//
// The ratio is a fraction of the card's pixel width — the equivalent of
// `cqi` for React Native, which doesn't honor CSS container queries on
// iOS/Android.

/** Fraction of the card's pixel width used for the due-line font size. */
const DUE_LINE_FONT_RATIO = 0.05;

/**
 * Top padding on the due-line label. The card tile reserves this plus
 * {@link getDueLineFontSize} when allocating the back-half height.
 */
export const DUE_LINE_PADDING_TOP_PX = 2;

// Readability floor, applied identically on every platform. Chosen to match
// the original iOS phone-thumbnail render (9px) so a 390px iOS phone keeps
// its long-standing look.
const DUE_LINE_FONT_MIN_PX = 9;

export function getDueLineFontSize(tileSize: number): number {
  return Math.max(DUE_LINE_FONT_MIN_PX, tileSize * DUE_LINE_FONT_RATIO);
}
